<template>
  <CollectionQuestion
    ref="child"
    v-if="someProgramIsOffered"
    v-on:answerUpdated="onAnswerUpdated"
    :question="questionWithFilteredProgramOptions"
    :answer="answer"
    :isDisabled="isDisabled"
    :key="childKey"
  ></CollectionQuestion>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import ParkPrograms from '@/services/park_programs'
  import CollectionQuestion from './CollectionQuestion'

  const PROGRAMS_FIELD_UUID = 'eada268d-ca2d-4466-950a-9324ba93ddb6'

  export default {
    name: 'FinanceIndicatorsQuestion',
    components: { CollectionQuestion },
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    data () {
      return {
        dependenciesByOptionName: {
          'Aceleração de empresas': ParkPrograms.ACCELERATION,
          'Empresa associada': ParkPrograms.ASSOCIATION,
          'Coworking': ParkPrograms.COWORKING,
          'Incubação de empresas': ParkPrograms.INCUBATION,
          'Graduação de empresas': ParkPrograms.INCUBATION,
          'Pré-incubação de empresas': ParkPrograms.PRE_INCUBATION,
          'Empresa residente': ParkPrograms.RESIDENCY
        },
        childKey: Math.floor(Math.random() * 999)
      }
    },
    computed: {
      someProgramIsOffered () {
        return Object.values(this.dependenciesByOptionName).some(
          (program) => ParkPrograms.has(program, this.quizAnswers)
        )
      },
      questionWithFilteredProgramOptions () {
        const filteredQuestion = cloneDeep(this.question)

        const programsField = filteredQuestion.fields.find(field => field.uuid === PROGRAMS_FIELD_UUID)
        programsField.options = programsField.options.filter((option) => {
          return ParkPrograms.has(this.dependenciesByOptionName[option], this.quizAnswers)
        })

        return this.sortQuestionFieldsByRenderingOrder(filteredQuestion)
      },
      offeredParkPrograms () {
        const programsField = this.questionWithFilteredProgramOptions.fields.find(
          field => field.uuid === PROGRAMS_FIELD_UUID
        )
        return programsField.options
      }
    },
    methods: {
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      },
      sortQuestionFieldsByRenderingOrder (question) {
        question.fields.sort((a, b) => a.renderingOrder - b.renderingOrder)
        return question
      },
      isValid () {
        if (!this.someProgramIsOffered) {
          return true
        }
        return this.$refs.child.isValid()
      },
      updateAnswerWhenParkProgramsChange () {
        if (!this.answer || !this.answer.value) {
          return
        }

        const updatedAnswer = this.answerWithoutUnavailableProgramsSelected(this.answer)
        this.$emit('answerUpdated', updatedAnswer)
      },
      answerWithoutUnavailableProgramsSelected (answer) {
        const mappedRows = answer.value.map((row) => {
          const programFieldAnswerIndex = row.findIndex(field => field.fieldUuid === PROGRAMS_FIELD_UUID)
          if (this.rowSelectedProgramIsOffered(row, programFieldAnswerIndex)) {
            return row
          }
          return this.rowWithoutInconsistentSelectedProgram(row, programFieldAnswerIndex)
        })

        return {...answer, value: mappedRows}
      },
      rowSelectedProgramIsOffered (row, programFieldAnswerIndex) {
        const programFieldAnswer = row[programFieldAnswerIndex]
        const [selectedProgram] = programFieldAnswer.value ? programFieldAnswer.value : []
        return this.offeredParkPrograms.includes(selectedProgram)
      },
      rowWithoutInconsistentSelectedProgram (row, programFieldAnswerIndex) {
        const rowClone = cloneDeep(row)
        rowClone[programFieldAnswerIndex].value = null
        return rowClone
      },
      forceChildRerender () {
        this.childKey += 1
      }
    },
    watch: {
      questionWithFilteredProgramOptions: {
        immediate: true,
        handler () {
          this.updateAnswerWhenParkProgramsChange()
          this.forceChildRerender()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FinanceIndicatorsQuestion.vue?29e9bda0